import axios from 'axios'
const baseUrl = `/api/filter`

const filterClient = newObject => {
    const request = axios.post(`${baseUrl}/filter`, newObject)
    return request.then(response => response.data)
}

// eslint-disable-next-line
export default { filterClient };